import { LDOptionsInterface } from '../../../definitions/interfaces';

export const LD_OPTIONS: LDOptionsInterface = {
  // Store flags in localstorage and load from there before the client is ready
  bootstrap: 'localStorage',
  // Sends telemetry info to LD every time a flag is loaded
  sendEventsOnlyForVariation: false,
  // Enable live updates of feature flags
  streaming: true,
};
